import React from "react"
import Icon from "../icon/icon.component"
import LoadingSpinner from "../spinner/loading.component"
import {FormattedMessage} from "react-intl"
import GlobalHelper from "../GlobalHelper"

export const DropdownItemPrint = (printUrl: string) => {
    return {
        children: <>
            {printUrl ? <>
                <Icon value={"print"} className={"mr-1"}/>
                <FormattedMessage
                    id="inventory_components_footer_print"
                    defaultMessage="Print"/> </> :
                <LoadingSpinner height={10}/>
            }
        </>,
        onClickCallback: printUrl ? () => GlobalHelper.redirectToPrintPdf(printUrl) : undefined
    }
}


// WEBPACK FOOTER //
// ./src/common/dropdown/DropdownItemPrint.tsx